import Link from "next/link";
import useFetchData from "../hooks/useFetchData";
import { DEFAULT_SUPPORTED_CHAINS } from "@usedapp/core";
import ImageProcessor from "./ImageProcessor";
import { KARATDAO_DEFAULT_SUPPORTED_CHAINS } from "@/chain-info/KaratDaoSupportedChain";
import { getChainIcon } from "@/utils/format";

export const AirdropGridItem = ({ campaign, feature }) => {
  const {
    // loading: baseInfoURILoading,
    // error: baseInfoURIError,
    data: baseInfoURIData,
  } = useFetchData(campaign?.baseInfo);
  const expectedChain = KARATDAO_DEFAULT_SUPPORTED_CHAINS.find(
    (network) => network.chainId === campaign?.chainId
  );
  const chainName = expectedChain?.chainName;
  const chainNameEth = chainName === "Mainnet" ? "Ethereum" : chainName;
  // const icon = useMemo(() => {
  //   return chainName
  //     ? `https://defillama.com/chain-icons/${chainLogo}.jpg`
  //     : '/unknown-logo.png';
  // }, [chainName, chainLogo]);
  const chainIcon = getChainIcon(chainNameEth);
  const dynamic_fit = campaign?.name?.includes("StepG&Karat")
    ? "object-contain"
    : "object-cover";
  if (
    campaign?.airdropAddr === "0xcaaac618b5dec930c4c7c00d011a91196b112427" &&
    campaign?.name === "Hay twitter airdrop campaign for eligible winners"
  ) {
    campaign.name = "HAY twitter airdrop campaign for eligible winners";
  }

  return (
    <Link
      href={`/airdrops/${chainName}/${campaign?.type?.toLowerCase()}/${
        campaign?.airdropAddr
      }`}
      passHref
    >
      <a
        className=" flex flex-col justify-between rounded-sm bg-white text-dark1"
        style={{
          filter: "drop-shadow(15px 4px 40px rgba(0, 0, 0, 0.1))",
        }}
      >
        <div
          className={
            feature
              ? "flex flex-col justify-between"
              : "flex flex-col justify-between"
          }
        >
          <div className="relative">
            <div className="absolute left-[6px] top-[6px] rounded-full flex items-center justify-center">
              <img alt="chainIcon" src={chainIcon} className="h-5 w-5" />
            </div>

            {/* <p style={load ? {} : { display: 'none' }}>loading</p> */}
            <ImageProcessor
              src={baseInfoURIData?.image}
              size="s300"
              className={
                feature
                  ? ` h-[235px] w-full rounded-t-md ${dynamic_fit} bg-black object-center `
                  : ` h-24 w-full rounded-t-md ${dynamic_fit} object-center `
              }
            />
          </div>

          <div
            id="card-content"
            className={
              feature
                ? " py-2 h-20 rounded-b-md px-2 font-bold text-dark1 bg-[#292939]/70"
                : " my-2 rounded-md px-2  text-dark1"
            }
            // style={{justifyContent:feature?"space-between":""}}
          >
            <div className="flex h-full flex-col justify-between">
              <div className="flex flex-col">
                <div
                  className={`font-bold  text-sm  line-clamp-2 ${
                    feature ? "text-white" : "text-dark1"
                  }`}
                >
                  {campaign?.name}
                </div>
                {!feature && (
                  <div className=" mb-1 flex flex-row justify-between">
                    <div className="text-xs text-[#B3B8B8] opacity-50">
                      {chainNameEth}
                    </div>
                  </div>
                )}
              </div>
              <div className="flex flex-col">
                <div className=" flex flex-row justify-between">
                  <div
                    className="text-sm text-dark1 opacity-50"
                    style={{ display: feature ? "none" : "" }}
                  >
                    Total
                  </div>
                  <div
                    className="text-sm text-dark1 opacity-50"
                    style={{ display: feature ? "none" : "" }}
                  >
                    Claimable
                  </div>
                </div>

                <div
                  className={
                    feature
                      ? " flex flex-row text-white text-xs"
                      : "flex flex-row justify-between text-dark1 text-xs"
                  }
                >
                  <div style={{ display: feature ? "" : "none" }}>
                    Supply:&nbsp;
                  </div>
                  <div>{campaign?.reach?.toString()}</div>
                  <div style={{ display: feature ? "none" : "" }}>
                    {campaign?.type === "NFT" ? "NFT" : "TOKEN"}{" "}
                  </div>
                </div>
              </div>
              {/* <div class="text-dark1 ">{element.symbol}</div> */}
            </div>
          </div>
        </div>
        <div
          className="text-secondary flex items-center justify-center rounded-b-md bg-primary text-white py-1"
          style={{ display: feature ? "none" : "" }}
        >
          Claim
        </div>
      </a>
    </Link>
  );
};
